export const i18n = {
	defaultLocale: 'en',
	locales: ['ko', 'en', 'de', 'fr', 'ja', 'vi', 'th', 'es', 'id', 'ms', 'zh'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export const localURLMap = {
	'de-DE': '/de',
	'en-GB': '/en',
	'en-US': '/en',
	'es-ES': '/es',
	'es-MX': '/es',
	'fr-FR': '/fr',
	'id-ID': '/id',
	'ja-JP': '/ja',
	'ko-KR': '/ko',
	'ms-MY': '/ms',
	'th-TH': '/th',
	'vi-VN': '/vi',
	'zh-CN': '/zh',
	'zh-HK': '/zh',
	'zh-TW': '/zh',
} as const;

export const localeMap = {
	de: 'de-DE',
	en: 'en-US',
	es: 'es-ES',
	fr: 'fr-FR',
	id: 'id-ID',
	ja: 'ja-JP',
	ko: 'ko-KR',
	ms: 'ms-MY',
	th: 'th-TH',
	vi: 'vi-VN',
	zh: 'zh-CN',
} as const;
